export default __webpack_public_path__ + "static/media/tutorial-02.5624aa42.jpg";